export default "__VITE_ASSET___JJ7DTwH__"